import React from "react";

import { ProductLabel } from "@components/Product/Layout/ProductLabel/productLabel.component";

import { PromotionPeriod } from "../../../PromotionPeriod/promotionPeriod.container";
import { ECommerceProduct } from "../../eCommerce.types";

export type DiscountProps = {
    discountPercentage?: number | null;
    product: ECommerceProduct;
};

const Discount = ({ discountPercentage, product }: DiscountProps) => {
    if (!discountPercentage) return null;

    return (
        <>
            <div className="row mb-2">
                <ProductLabel
                    text="Promo"
                    secondary={`${discountPercentage}%`}
                />
            </div>
            {!product.boxArticle && (
                <PromotionPeriod
                    salesIncentives={product.salesIncentives}
                    promotions={product.price?.promotions ?? []}
                    className={"row"}
                />
            )}
        </>
    );
};

export default Discount;
